import React, { useEffect, useState, useRef } from "react";
import { Images } from "../Common/Images";

const NotificationMessage = ({
  type = "success",
  title,
  message,
  duration = 3000,
  onClose
}) => {

  const [visible, setVisible] = useState(true);
  const hasStarted = useRef(false);

  useEffect(() => {

    if (hasStarted.current) return;
    hasStarted.current = true;

    const timer = setTimeout(() => {
      setVisible(false);
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);

  }, []);

  if (!visible) return null;

  const isSuccess = type === "success";

  return (
    <div
      className={`${isSuccess ? "successful" : "error"}-message-wrapper`}
    >
      <div
        className={`${isSuccess ? "successful" : "error"}-message-inner d-flex align-items-start gap-3`}
      >
        <div className={`${isSuccess ? "successful" : "error"}-icon`}>
          <img
            src={
              isSuccess
                ? Images.SuccessIcon
                : Images.AlertIcon
            }
            className="img-fluid"
            alt="notification-icon"
          />
        </div>

        <div className={`${isSuccess ? "success" : "error"}-content`}>
          <h6>{title}</h6>
          <p>{message}</p>
        </div>

        {/* Optional Close Button */}
        {/*  <button
          style={{ marginLeft: "auto", background: "none", border: "none" }}
          onClick={() => setVisible(false)}
        >
          ✕
        </button> */}
      </div>
    </div>
  );
};

export default NotificationMessage;
